import React from "react";
// @ts-ignore: allow side-effect CSS import without module declarations
import "react-toastify/dist/ReactToastify.css";
import { usePopupScreen } from "./hooks/usePopupScreen";
import Bom from "../Bom/Bom";
import CustomerForm from "./parts/CustomerForm";
import CustomerLedger from "./parts/CustomerLedger";
import CustomerSelection from "./parts/CustomerSelection";

interface Props {
  cartId: string | null;
  backHome: (value: string) => void;
  onDone: () => void;
  editedAmounts: { [productId: string]: string };
}

const PopupScreen: React.FC<Props> = ({ cartId, backHome, onDone, editedAmounts }) => {
  const { selectedCustomer, view, pageNumber, searchTerm, customers, total, loading, selectCustomer, addCustomer, handleSearchChange, setPageNumber, goBack, goToForm, goToBom } = usePopupScreen();

  return (
    <div>
      {/* <ToastContainer position="top-right"/> */}
      {view === "bom" && selectedCustomer && <Bom cartId={cartId} customerData={selectedCustomer} customerid={String(selectedCustomer._id.$oid)} backHomebom={goBack} backHome={backHome} onDone={onDone} editedAmounts={editedAmounts} />}
      {view === "form" && <CustomerForm onBack={goBack} onAdded={addCustomer} />}
      {view === "ledger" && selectedCustomer && <CustomerLedger customer={selectedCustomer} onBack={goBack} onConfirm={goToBom} onClose={goBack} onAddProduct={() => backHome("false")} />}
      {view === "selection" && (
        <CustomerSelection
          onSelectCustomer={selectCustomer}
          onAddCustomer={goToForm}
          backHome={() => backHome("false")}
          customers={customers}
          total={total}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          loading={loading}
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
        />
      )}
    </div>
  );
};

export default PopupScreen;
